import { render, staticRenderFns } from "./CreateStaffPopUp.vue?vue&type=template&id=45975693&scoped=true"
import script from "./CreateStaffPopUp.vue?vue&type=script&lang=js"
export * from "./CreateStaffPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateStaffPopUp.vue?vue&type=style&index=0&id=45975693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45975693",
  null
  
)

export default component.exports